import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import { getVistaPresupuestosInternosList } from '../../helpers/user_mv';
import helpers from '../../mixins/helpers';
import vendedor from './vendedor';

const state = {
    presupuestosDashboard: [],
    presupuestosPendientes: [],
    presupuestosConfirmados: [],
    presupuestosFacturados: [],
    presupuestosCerrados: [],
    presupuestosTodos: [],

    /* Paginacion */
    paginaActualPendientes: 1,
    registrosPorPaginaPendientes: 10,
    totalRegistrosPendientes: 0,
    totalPaginasPendientes: 0,

    paginaActualConfirmados: 1,
    registrosPorPaginaConfirmados: 10,
    totalRegistrosConfirmados: 0,
    totalPaginasConfirmados: 0,

    paginaActualFacturados: 1,
    registrosPorPaginaFacturados: 10,
    totalRegistrosFacturados: 0,
    totalPaginasFacturados: 0,

    paginaActualCerrados: 1,
    registrosPorPaginaCerrados: 10,
    totalRegistrosCerrados: 0,
    totalPaginasCerrados: 0,

    paginaActualTodos: 1,
    registrosPorPaginaTodos: 10,
    totalRegistrosTodos: 0,
    totalPaginasTodos: 0,

    /* Filtro */
    filtroNumero: false,
    filtroFechaRegistro: true,
    filtroFechaConfirmacion: false,
    filtroFechaCierre: false,
    fechaDesde: moment(new Date()).add(-60, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    fechaConfirmacionDesde: moment(new Date()).add(-60, 'days').format('YYYY-MM-DD'),
    fechaConfirmacionHasta: moment(new Date()).format('YYYY-MM-DD'),
    fechaCierreDesde: moment(new Date()).add(-60, 'days').format('YYYY-MM-DD'),
    fechaCierreHasta: moment(new Date()).format('YYYY-MM-DD'),
    numero: 0,
    cliente: null,
    contacto: null,
    accion: '',
    numeroPO: '',
    usuario: null,
    sortByDescending: true,

    /* Opciones adicionales */
    sortByFechaCierreEstimado: false,

    /* Vista a partir del usuario logueado */
    vistaPresupuestos: [],

    vistaPresupuestosPendientes: [],
    vistaPresupuestosConfirmados: [],
    vistaPresupuestosFacturados: [],
    vistaPresupuestosCerrados: [],
    vistaPresupuestosTodos: [],
    vistaPresupuestosDashboard: [],

    /* Permisos del usuario logueado */
    agregarVisible: true,

    existsPresupuesto: false,

    rptPresupuestos: [],
    rptPresupuestosPremios: [],
    rptAperturasCierres: [],

    vendedorComision: {}
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES' (state) {
        state.presupuestosDashboard = [];
        state.presupuestosPendientes = [];
        state.presupuestosConfirmados = [];
        state.presupuestosFacturados = [];
        state.presupuestosCerrados = [];
        state.presupuestosTodos = [];
    
        /* Paginacion */
        state.paginaActualPendientes = 1;
        state.registrosPorPaginaPendientes = 10;
        state.totalRegistrosPendientes = 0;
        state.totalPaginasPendientes = 0;
    
        state.paginaActualConfirmados = 1;
        state.registrosPorPaginaConfirmados = 10;
        state.totalRegistrosConfirmados = 0;
        state.totalPaginasConfirmados = 0;
    
        state.paginaActualFacturados = 1;
        state.registrosPorPaginaFacturados = 10;
        state.totalRegistrosFacturados = 0;
        state.totalPaginasFacturados = 0;
    
        state.paginaActualCerrados = 1;
        state.registrosPorPaginaCerrados = 10;
        state.totalRegistrosCerrados = 0;
        state.totalPaginasCerrados = 0;
    
        state.paginaActualTodos = 1;
        state.registrosPorPaginaTodos = 10;
        state.totalRegistrosTodos = 0;
        state.totalPaginasTodos = 0;
    
        /* Filtro */
        state.filtroNumero = false;
        state.filtroFechaRegistro = true;
        state.filtroFechaConfirmacion = false;
        state.filtroFechaCierre = false;
        state.fechaDesde = moment(new Date()).add(-60, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.fechaConfirmacionDesde = moment(new Date()).add(-60, 'days').format('YYYY-MM-DD');
        state.fechaConfirmacionHasta = moment(new Date()).format('YYYY-MM-DD');
        state.fechaCierreDesde = moment(new Date()).add(-60, 'days').format('YYYY-MM-DD');
        state.fechaCierreHasta = moment(new Date()).format('YYYY-MM-DD');
        state.numero = 0;
        state.cliente = null;
        state.contacto = null;
        state.accion = '';
        state.numeroPO = '';
        state.usuario = null;
        state.sortByDescending = true;
    
        /* Opciones adicionales */
        state.sortByFechaCierreEstimado = false;
    
        /* Vista a partir del usuario logueado */
        state.vistaPresupuestos = [];
    
        state.vistaPresupuestosPendientes = [];
        state.vistaPresupuestosConfirmados = [];
        state.vistaPresupuestosFacturados = [];
        state.vistaPresupuestosCerrados = [];
        state.vistaPresupuestosTodos = [];
        state.vistaPresupuestosDashboard = [];
    },

    'INICIALIZAR_PRESUPUESTOS' (state, params) {
        switch (params.estado.toLowerCase().trim()) {
            case "pendientes":
                state.presupuestosPendientes = [];
                break;
            case "confirmados":
                state.presupuestosConfirmados = [];
                break;
            case "facturados":
                state.presupuestosFacturados = [];
                break;
            case "cerrados":
                state.presupuestosCerrados = [];
                break;
            case "todos":
                state.presupuestosTodos = [];
                break;
            case "dashboard":
                state.presupuestosDashboard = [];
                break;
        }
    },
    'SET_PRESUPUESTOS' (state, params) {
        switch (params.estado.toLowerCase().trim()) {
            case "pendientes":
                state.presupuestosPendientes = params.presupuestos;
                break;
            case "confirmados":
                state.presupuestosConfirmados = params.presupuestos;
                break;
            case "facturados":
                // state.presupuestosFacturados = params.presupuestos;
                state.presupuestosFacturados = params.presupuestos.map(presupuesto => ({
                    ...presupuesto,
                    _rowVariant: moment(presupuesto.fechaCierreEstimado).format('YYYY-MM-DD') != '1900-01-01'
                        & moment(presupuesto.fechaCierreEstimado).format('YYYY-MM-DD') < moment.utc(new Date()).format('YYYY-MM-DD') ? 'danger' : ''
                }))
                break;
            case "cerrados":
                state.presupuestosCerrados = params.presupuestos;
                break;
            case "todos":
                state.presupuestosTodos = params.presupuestos;
                break;
            case "dashboard":
                state.presupuestosDashboard = params.presupuestos;
                break;
        }
    },
    'SET_PAGINATION'(state, params) {
        switch (params.estado.toLowerCase().trim()) {
            case "pendientes":
                state.paginaActualPendientes = params.paginaActual;
                state.registrosPorPaginaPendientes = params.registrosPorPagina;
                state.totalRegistrosPendientes = params.totalRegistros;
                state.totalPaginasPendientes = params.totalPaginas;
                break;
            case "confirmados":
                state.paginaActualConfirmados = params.paginaActual;
                state.registrosPorPaginaConfirmados = params.registrosPorPagina;
                state.totalRegistrosConfirmados = params.totalRegistros;
                state.totalPaginasConfirmados = params.totalPaginas;
                break;
            case "facturados":
                state.paginaActualFacturados = params.paginaActual;
                state.registrosPorPaginaFacturados = params.registrosPorPagina;
                state.totalRegistrosFacturados = params.totalRegistros;
                state.totalPaginasFacturados = params.totalPaginas;
                break;
            case "cerrados":
                state.paginaActualCerrados = params.paginaActual;
                state.registrosPorPaginaCerrados = params.registrosPorPagina;
                state.totalRegistrosCerrados = params.totalRegistros;
                state.totalPaginasCerrados = params.totalPaginas;
                break;
            case "todos":
                state.paginaActualTodos = params.paginaActual;
                state.registrosPorPaginaTodos = params.registrosPorPagina;
                state.totalRegistrosTodos = params.totalRegistros;
                state.totalPaginasTodos = params.totalPaginas;
                break;
        }
    },
    'SET_VISTA_PRESUPUESTOS' (state, params) {
        switch (params.estado.toLowerCase().trim()) {
            case "pendientes":
                state.vistaPresupuestosPendientes = params.vistaPresupuestos;
                break;
            case "confirmados":
                state.vistaPresupuestosConfirmados = params.vistaPresupuestos;
                break;
            case "facturados":
                state.vistaPresupuestosFacturados = params.vistaPresupuestos;
                break;
            case "cerrados":
                state.vistaPresupuestosCerrados = params.vistaPresupuestos;
                break;
            case "todos":
                state.vistaPresupuestosTodos = params.vistaPresupuestos;
                break;
            case "dashboard":
                state.vistaPresupuestosDashboard = params.vistaPresupuestos;
                break;
        }
    },
    'SET_PERMISOS' (state, user) {
        state.agregarVisible = true;
        
        if (user.rolId == 4 || user.rolId == 14) {        
            state.agregarVisible = false;
        }
    },
    'SET_CIERRE_ESTIMADO_PRESUPUESTO' (state, params) {
        let presupuesto = state.presupuestosFacturados.find(t => t.id == params.presupuestoInternoId);

        if (presupuesto) {
            presupuesto.fechaCierreEstimado = moment(params.fecha).format('YYYY-MM-DD');
            
            presupuesto._rowVariant = moment(presupuesto.fechaCierreEstimado).format('YYYY-MM-DD') != '1900-01-01'
                & moment(presupuesto.fechaCierreEstimado).format('YYYY-MM-DD') < moment.utc(new Date()).format('YYYY-MM-DD') ? 'danger' : '';
        }
    },

    'INICIALIZAR_RPT_PRESUPUESTOS' (state) {
        state.rptPresupuestos = [];
    },
    'SET_RPT_PRESUPUESTOS' (state, rptPresupuestos) {
        state.rptPresupuestos = rptPresupuestos;
    },

    'INICIALIZAR_RPT_PRESUPUESTOS_PREMIOS' (state) {
        state.rptPresupuestosPremios = [];
    },
    'SET_RPT_PRESUPUESTOS_PREMIOS' (state, rptPresupuestosPremios) {
        state.rptPresupuestosPremios = rptPresupuestosPremios;
    },

    'INICIALIZAR_RPT_APERTURAS_CIERRES' (state) {
        state.rptAperturasCierres = [];
    },
    'SET_RPT_APERTURAS_CIERRES' (state, rptAperturasCierres) {
        state.rptAperturasCierres = rptAperturasCierres;
    },

    'INICIALIZAR_VALIDACION_EXISTS' (state) {
        state.existsPresupuesto = false;
    },
    'SET_VALIDACION_EXISTS' (state, existsPresupuesto) {
        state.existsPresupuesto = existsPresupuesto;
    },
    
    'INICIALIZAR_VENDEDOR_COMISION' (state) {
        state.vendedorComision = false;
    },
    'SET_VENDEDOR_COMISION' (state, vendedorComision) {
        state.vendedorComision = vendedorComision;
    },
};

const getters = {
    getField,
    presupuestosDashboard (state) {
        return state.presupuestosDashboard;
    },
    vistaPresupuestosPendientes (state) {
        return state.vistaPresupuestosPendientes;
    },
    vistaPresupuestosConfirmados (state) {
        return state.vistaPresupuestosConfirmados;
    },
    vistaPresupuestosFacturados (state) {
        return state.vistaPresupuestosFacturados;
    },
    vistaPresupuestosCerrados (state) {
        return state.vistaPresupuestosCerrados;
    },
    vistaPresupuestosTodos (state) {
        return state.vistaPresupuestosTodos;
    },
    vistaPresupuestosDashboard (state) {
        return state.vistaPresupuestosDashboard;
    },
    rptPresupuestos(state) {
        return state.rptPresupuestos;
    },
    rptPresupuestosPremios(state) {
        return state.rptPresupuestosPremios;
    },
    rptAperturasCierres(state) {
        return state.rptAperturasCierres;
    },
    existsPresupuesto(state) {
        return state.existsPresupuesto;
    },
    vendedorComision(state) {
        return state.vendedorComision;
    }
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },

    getPresupuestos ( { commit, rootState }, estado ) {
        return new Promise((resolve, reject) => {
            let params = {
                estado: estado
            }

            commit('INICIALIZAR_PRESUPUESTOS', params);
            
            let url = 'presupuestosinternos' + (estado != 'todos' ? '/' + estado : '');
            
            let queryString = '';

            if (estado.trim() != 'dashboard') {

                if ((/true/i).test(state.filtroNumero)) {
                    queryString = '?numero=' + state.numero;
                } else {
                    if ((/true/i).test(state.filtroFechaCierre)) {
                        /* Filtramos por fecha de cierre */
                        queryString = '?fechaCierreDesde='+ moment(state.fechaCierreDesde).format('YYYY-MM-DD')
                            + '&fechaCierreHasta='+ moment(state.fechaCierreHasta).format('YYYY-MM-DD');
                    } else if ((/true/i).test(state.filtroFechaConfirmacion)) {
                        /* Filtramos por fecha de confirmacion */
                        queryString = '?fechaConfirmacionDesde='+ moment(state.fechaConfirmacionDesde).format('YYYY-MM-DD')
                            + '&fechaConfirmacionHasta='+ moment(state.fechaConfirmacionHasta).format('YYYY-MM-DD');
                    } else {
                        /* Filtramos por fecha de registro */
                        queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                            + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
                    }

                    if (state.cliente) {
                        if (state.cliente.id != 0) {
                            queryString += '&clienteId=' + state.cliente.id;
                        }
                    }
                    if (state.contacto) {
                        if (state.contacto.id != 0) {
                            queryString += '&contactoId=' + state.contacto.id;
                        }
                    }
                    if (state.accion.trim() != '') {
                        queryString += '&accion=' + state.accion.trim();
                    }
                    if (state.numeroPO.trim() != '') {
                        queryString += '&numeroOrdenCompra=' + state.numeroPO.trim();
                    }
                    if (state.usuario) {
                        if (state.usuario.id != 0) {
                            queryString += '&usuarioId=' + state.usuario.id;
                        }
                    }
                }

                queryString += '&sortByDescending='+ state.sortByDescending;
                    
                switch (params.estado.toLowerCase().trim()) {
                    case "pendientes":
                        queryString += '&pageSize=' + state.registrosPorPaginaPendientes
                            + '&pageNumber=' + state.paginaActualPendientes;
                        break;
                    case "confirmados":
                        queryString += '&pageSize=' + state.registrosPorPaginaConfirmados
                            + '&pageNumber=' + state.paginaActualConfirmados;
                        break;
                    case "facturados":
                        queryString += '&pageSize=' + state.registrosPorPaginaFacturados
                            + '&pageNumber=' + state.paginaActualFacturados;

                        if ((/true/i).test(state.sortByFechaCierreEstimado)) {
                            queryString += '&SortByFechaCierreEstimado=true';
                        }
                        break;
                    case "cerrados":
                        queryString += '&pageSize=' + state.registrosPorPaginaCerrados
                            + '&pageNumber=' + state.paginaActualCerrados;
                        break;
                    case "todos":
                        queryString += '&pageSize=' + state.registrosPorPaginaTodos
                            + '&pageNumber=' + state.paginaActualTodos;
                        break;
                }
            } else {
                url = 'presupuestosinternos/pendientes';

                queryString = '?sortByDescending=true'
                    + '&pageSize=15' 
                    + '&pageNumber=1';
            }
        
            apiAxios.get(url + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        let paginationParams = {
                            estado: estado,
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', paginationParams);
                    }

                    let resultParams = {
                        estado: estado,
                        presupuestos: res.data
                    }
                    commit('SET_PRESUPUESTOS', resultParams);

                    /* Recuperamos la vista de acuerdo al usuario logueado */
                    let vistaParams = {
                        estado,
                        vistaPresupuestos: getVistaPresupuestosInternosList(estado)
                    }
                    commit('SET_VISTA_PRESUPUESTOS', vistaParams);

                    /* Seteamos los permisos del usuario */
                    commit('SET_PERMISOS', rootState.user);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    delete ( {}, presupuestoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`presupuestosinternos/${presupuestoId}/delete`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    duplicarPresupuesto ( {}, params) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`presupuestosinternos/${params.presupuestoInternoId}/duplicar`, params)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    cancelarPresupuesto ( {}, params) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`presupuestosinternos/${params.presupuestoInternoId}/cancelar`, params)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    restablecerPresupuesto ( {}, presupuestoInternoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`presupuestosinternos/${presupuestoInternoId}/restablecer`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    cerrarPresupuesto ( {}, params) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`presupuestosinternos/${params.presupuestoInternoId}/cerrar`, params)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    abrirPresupuesto ( {}, params) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`presupuestosinternos/${params.presupuestoInternoId}/abrir`, params)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    autorizarPresupuesto ( {}, params) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`presupuestosinternos/${params.presupuestoInternoId}/autorizar`, params)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    cancelarAutorizacionPresupuesto ( {}, presupuestoInternoId) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`presupuestosinternos/${presupuestoInternoId}/autorizacion/delete`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    setCierreEstimadoPresupuesto ( { commit }, params) {
        return new Promise((resolve, reject) => {
            commit('SET_CIERRE_ESTIMADO_PRESUPUESTO', params);
            resolve();
        })            
    },
    getRptPresupuestos ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_PRESUPUESTOS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');
        
            if (params.clienteId) {
                if (params.clienteId != 0) {
                    queryString += '&clienteId=' + params.clienteId;
                }
            }
            if (params.estadoId) {
                if (params.estadoId != 0) {
                    queryString += '&estadoId=' + params.estadoId;
                }
            }

            apiAxios.get('presupuestosinternos/rpt' + queryString)
                .then(res => {
                    commit('SET_RPT_PRESUPUESTOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getRptPresupuestosCancelados ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_PRESUPUESTOS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');
        
            if (params.clienteId) {
                if (params.clienteId != 0) {
                    queryString += '&clienteId=' + params.clienteId;
                }
            }

            apiAxios.get('presupuestosinternos/rpt/cancelados' + queryString)
                .then(res => {
                    commit('SET_RPT_PRESUPUESTOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getRptPresupuestosPremios ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_PRESUPUESTOS_PREMIOS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');
        
            if (params.clienteId != 0) {
                queryString += '&clienteId=' + params.clienteId;
            }

            apiAxios.get('presupuestosinternos/rpt-premios' + queryString)
                .then(res => {
                    commit('SET_RPT_PRESUPUESTOS_PREMIOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getRptAperturasCierres ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_APERTURAS_CIERRES');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');
        
            if (params.clienteId != 0) {
                queryString += '&clienteId=' + params.clienteId;
            }

            apiAxios.get('presupuestosinternos/rpt/aperturas-cierres' + queryString)
                .then(res => {
                    commit('SET_RPT_APERTURAS_CIERRES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getRptPresupuestosCerrados ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_PRESUPUESTOS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');
        
            if (params.clienteId) {
                if (params.clienteId != 0) {
                    queryString += '&clienteId=' + params.clienteId;
                }
            }

            apiAxios.get('presupuestosinternos/rpt/cerrados' + queryString)
                .then(res => {
                    commit('SET_RPT_PRESUPUESTOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    existsPresupuestoByClienteAccion ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_VALIDACION_EXISTS');

            let queryString = '?clienteId='+ params.clienteId
                + '&accion='+ params.accion;
        
            apiAxios.get('presupuestosinternos/exists' + queryString)
                .then(res => {
                    let status = parseInt(res.status);

                    if (status == 200) {
                        commit('SET_VALIDACION_EXISTS', true);
                        resolve();
                    } else if (status == 204) {
                        commit('SET_VALIDACION_EXISTS', false);
                        resolve();
                    } else {
                        reject('Se produjo un error al validar la información del presupuesto interno.');
                    }
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    cancelarSaldoVendedorComision: ( { commit }, params ) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_VENDEDOR_COMISION');

            const baseImporte = {
                importe: params.importe,
                observaciones: params.observaciones
            }

            apiAxios.post(`presupuestosinternos/${params.presupuestoInternoId}/comisiones/${params.vendedorId}/ventas/${params.ventaId}/cancelar-saldo`, baseImporte)
                .then(res => {
                    commit('SET_VENDEDOR_COMISION', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            

    },
    anularCancelacionSaldoVendedorComision: ( {}, presupuestoInternoId ) => {
            apiAxios.post(`presupuestosinternos/${presupuestoInternoId}/comisiones/anular-cancelacion-saldo`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}